/**
 * Types for the signup-without-payment flow only.
 * Kept separate from existing auth types.
 */

/** Plan ID used when signup-without-payment is used as a free trial (no card). */
export const SIGNUP_WITHOUT_PAYMENT_FREE_TRIAL_PLAN_ID = 'AI-Flow-Trial-Plan-USD-Monthly';

export interface SignupWithoutPaymentUtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  [key: string]: string | undefined;
}

export interface SignupWithoutPaymentRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  companyName?: string;
  timezone?: string;
  phoneNumber?: string;
  subdomain?: string;
  /** Free trial plan ID when signup-without-payment is used as free trial. Sent separately from other signup flows. */
  planId?: string;
  utm_params?: SignupWithoutPaymentUtmParams;
}

/** New company response */
export interface SignupWithoutPaymentResponseNewCompany {
  message: string;
  userSub: string;
  companyId: string;
  companyName: string;
  subscriptionId: string;
}

/** Existing company (invite) response */
export interface SignupWithoutPaymentResponseExistingCompany {
  message: string;
  userSub: string;
  companyId: string;
}

export type SignupWithoutPaymentResponse =
  | SignupWithoutPaymentResponseNewCompany
  | SignupWithoutPaymentResponseExistingCompany;

export function hasCompanyName(
  r: SignupWithoutPaymentResponse
): r is SignupWithoutPaymentResponseNewCompany {
  return 'companyName' in r && typeof (r as SignupWithoutPaymentResponseNewCompany).companyName === 'string';
}
